import { render, staticRenderFns } from "./PaymentFailureDialog.vue?vue&type=template&id=6de3bde0"
import script from "./PaymentFailureDialog.vue?vue&type=script&lang=js"
export * from "./PaymentFailureDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports